import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Conditional Tailwind class joiner (deduplicates conflicting utilities). */
export function cn(...inputs: ClassValue[]): string {
    return twMerge(clsx(inputs));
}
